"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const images_1 = require("@dialogexe/cw-asset-provider/images");
class ScheduleItem extends React.Component {
    constructor() {
        super(...arguments);
        this.onScroll = () => {
            if (this.props.isLastItem && this.isInViewport()) {
                this.props.getMoreEvents();
            }
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.onScroll, false);
    }
    ;
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll, false);
    }
    ;
    isInViewport(offset = 0) {
        if (!this.eventRow)
            return false;
        const top = this.eventRow.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }
    render() {
        const { event, showTicketCount } = this.props;
        const adFlags = this.getMappedAdFlags(event);
        return (React.createElement("div", { className: "event-row", ref: (el) => this.eventRow = el },
            React.createElement("div", { className: `event-item ${event.club ? 'with-attachment' : ''}` },
                React.createElement("a", { href: this.resolveLinkPath(event), className: "event row is-visible-mobile" },
                    React.createElement("div", { className: "column is-xs-3" },
                        React.createElement("img", { src: event.image, alt: "" })),
                    React.createElement("div", { className: "column is-xs-9" },
                        React.createElement("h3", { className: "event-title" }, event.title),
                        React.createElement("div", { className: "event-info" },
                            this.getTime(event.startDate),
                            ", ",
                            event.location),
                        React.createElement("div", { className: "badge-list" },
                            event.features.filter(f => f.name).map((feature, index) => (React.createElement("div", { key: index, className: `badge ${feature.highlight ? 'is-highlight' : ''}` }, feature.name))),
                            adFlags.map((flag, index) => (React.createElement("div", { key: index, className: "badge" }, flag)))))),
                React.createElement("div", { className: "event row is-hidden-mobile" },
                    React.createElement("div", { className: "column is-md-2 is-lg-1" },
                        React.createElement("a", { href: this.resolveLinkPath(event) },
                            React.createElement("img", { src: event.image, alt: "" }))),
                    React.createElement("div", { className: "column is-lg-2 is-visible-desktop" },
                        React.createElement("h3", { className: "event-title" }, this.getTime(event.startDate)),
                        React.createElement("p", { className: "event-info" },
                            "Slutt ca. ",
                            this.getTime(event.endDate))),
                    React.createElement("div", { className: "column is-lg-5 is-md-7" },
                        React.createElement("a", { href: this.resolveLinkPath(event), className: "event-title-name" },
                            React.createElement("h3", { className: "event-title" }, event.title)),
                        React.createElement("div", { className: "event-info is-visible-tablet" },
                            this.getTime(event.startDate),
                            ", ",
                            event.location),
                        React.createElement("div", { className: "badge-list" },
                            event.features.filter(f => f.name).map((feature, index) => (React.createElement("div", { key: index, className: `badge ${feature.highlight ? 'is-highlight' : ''}` }, feature.name))),
                            adFlags.map((flag, index) => (React.createElement("div", { key: index, className: "badge is-highlight" }, flag))))),
                    React.createElement("div", { className: "column is-lg-2 is-visible-desktop" },
                        React.createElement("h3", { className: "event-title" }, event.location),
                        showTicketCount &&
                            React.createElement("div", { className: "event-info" },
                                event.ticketCountLow &&
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("img", { src: icons_1.exclamationIcon })),
                                event.ticketCount,
                                " ledige")),
                    React.createElement("div", { className: "column" },
                        React.createElement("div", { className: "event-actions" }, event.links.filter(link => link.path && !link.hidden).map((link, index) => this.renderLink(event, link, index))))),
                event.club &&
                    React.createElement("div", { className: "club-stripe" },
                        React.createElement("div", { className: "expanded" },
                            React.createElement("span", { className: "hidden-mobile" }, "Denne filmen kan sees p\u00E5 kino til 50% for"),
                            React.createElement("span", null,
                                React.createElement("img", { src: images_1.kinoklubbBlackImage, alt: "kinoklubb" })),
                            React.createElement("span", { className: "hidden-mobile" }, "-medlemmer")),
                        React.createElement("div", null,
                            React.createElement("a", { href: "https://www.kinoklubb.no", target: "_blank" }, "Les mer"))))));
    }
    renderLink(event, link, index) {
        let label = link.label;
        let className = link.primary ? 'is-primary' : '';
        if (link.sales && event.ticketSalesActive === false) {
            className = 'is-disabled';
            label = 'Utsolgt';
        }
        if (link.sales && event.ticketSalesEnabled === false) {
            className = 'is-disabled';
            label = 'Salg ikke åpnet';
        }
        return (React.createElement("a", { key: index, href: this.buildLinkWithDateFilter(link.path, event.startDate), className: `button is-contained ${className}` }, label));
    }
    getMappedAdFlags(event) {
        const flags = [];
        if (!event.adFlags || !event.adFlagsView) {
            return [];
        }
        event.adFlags.forEach(flag => {
            const flagView = event.adFlagsView.find(flagView => (flagView.flag === flag));
            if (flagView) {
                flags.push(flagView.view);
            }
        });
        return flags;
    }
    formatDateFromDay(date) {
        return moment(date).format('YYYY-MM-DD');
    }
    getTime(date) {
        return moment(date).format('HH:mm');
    }
    resolveLinkPath(event) {
        const links = event.links.filter(link => link.path);
        if (links.length < 1) {
            return null;
        }
        return this.buildLinkWithDateFilter(links[0].path, event.startDate);
    }
    buildLinkWithDateFilter(link, date) {
        return `${link}?cw-movie-info-from=${this.formatDateFromDay(date)}`;
    }
}
exports.ScheduleItem = ScheduleItem;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-schedule/ScheduleItem.tsx